
<div *ngIf="showMessage" class="status-modal-box  transition delay scale-1" [ngClass]="{'show-modal-box': showMessage, 'hide-modal-box': !showMessage}">
    <div class="status-card transition w-100per position-fixed top-10 bg-white-color modal-box-card d-flex flex-y-center w-100per justify-space-between p-10-20 bdr-radius-10 mb-10">
      <div class="d-flex flex-y-center">
        <img
          src="{{commonService.aws_asset_url}}/_assets/icons/light-mode/{{alertType=='error-box' ? 'red-circle-error.svg' :
            alertType=='success-box' ? 'green-sucess.svg' : 
            alertType=='warning-box' ? 'red-warning.svg' : 
            null }}"
          width="20px"
          height="20px"
          alt="alert-logo"
          class="mr-20"
        />
        <div class="ml-10">
          <h4 class="m-0 text-size-18 text-bold"
          [ngClass]="{'text-red': alertType=='error-box', 'text-orange-color': alertType=='warning-box', 'text-green' :  alertType=='success-box' }">
            {{alertType === "error-box"
            ? "Error"
            : alertType === "warning-box"
            ? "Warning"
            : alertType === "success-box"
            ? "Success"
            : null}}
          </h4>
          <small className="text-dark-grey-color text-size-12 mt-5 mb-0">
           {{message}}
          </small>
        </div>
      </div>
      <img
        src="{{commonService.aws_asset_url}}/_assets/icons/red-close.svg"
        alt="close-btn"
        (click)="hideError()"
        className=" close-btn"
      />
    </div>
  </div>
  
  <div class="modal-body">
    <form [formGroup]="masterForm" style="margin-top: -10px">
        <div class="form-group text-input-field">
            <select class="input-field" formControlName="parent_id" [ngClass]="{'error-field': (!masterForm.controls.parent_id.valid && submitted),
                'success-field' : masterForm.controls.parent_id.valid && masterForm.controls.parent_id.dirty}">
                <option selected disabled>SELECT</option>
                <ng-container *ngIf="groupList != undefined">
                <option *ngFor="let item of groupList" value="{{item.id}}">{{item.name}}</option>
                </ng-container>
            </select>
            <label
                [ngClass]="{'error-label': masterForm.controls.parent_id.invalid && masterForm.controls.parent_id.dirty || (!masterForm.controls.parent_id.valid && submitted)}">Group
                <ng-container
                *ngIf="masterForm.controls.parent_id.invalid && masterForm.controls.parent_id.dirty || (!masterForm.controls.parent_id.valid && submitted)">
                <i class="fa fa-info-circle ml-2" title="Group Required" aria-hidden="true"></i>
                </ng-container>
            </label>
        </div>

        <div class="form-group text-input-field">
            <div class="text-input-field mr-2" (focus)="focusAccountAc()" >
                <input class="input-field" oninput="this.value = this.value.toUpperCase()" id="master_name" name="name" #accountAc
                  formControlName="name" type="text" [ngClass]="{'error-field': masterForm.controls.name.invalid && masterForm.controls.name.dirty  || (!masterForm.controls.name.valid && submitted),
                    'success-field' : masterForm.controls.name.valid && masterForm.controls.name.dirty}" />
                <label
                  [ngClass]="{'error-label': masterForm.controls.name.invalid && masterForm.controls.name.dirty || (!masterForm.controls.name.valid && submitted)}">Name
                  <span class="text-danger">*</span>
                  <ng-container
                    *ngIf="masterForm.controls.name.invalid && masterForm.controls.name.dirty || (!masterForm.controls.name.valid && submitted)">
                    <i class="fa fa-info-circle ml-2" title="Account Required" aria-hidden="true"></i>
                  </ng-container>
                </label>
              </div>

              <div class="text-input-field" *ngIf="masterType == 'client'">
                <input class="input-field" oninput="this.value = this.value.toUpperCase()" name="contact_person" tabIndex="2"
                  formControlName="contact_person" type="text" [ngClass]="{'error-field':  masterForm.controls.contact_person && masterForm.controls.contact_person.invalid && masterForm.controls.contact_person.dirty  || (!masterForm.controls.contact_person.valid && submitted),
                    'success-field' :  masterForm.controls.contact_person && masterForm.controls.contact_person.valid && masterForm.controls.contact_person.dirty}" />
                <label
                  [ngClass]="{'error-label':  masterForm.controls.contact_person && masterForm.controls.contact_person.invalid && masterForm.controls.contact_person.dirty || (!masterForm.controls.contact_person.valid && submitted)}">Contact Person
                  <span class="text-danger">*</span>  
                  <ng-container
                    *ngIf=" masterForm.controls.contact_person && masterForm.controls.contact_person.invalid && masterForm.controls.contact_person.dirty || (!masterForm.controls.contact_person.valid && submitted)">
                    <i class="fa fa-info-circle ml-2" title="Contact Person Required" aria-hidden="true"></i>
                  </ng-container>
                </label>
        
              </div>

              <div class="text-input-group d-flex justify-content-between"  *ngIf="masterType == 'client'">
                <div class="text-input-field mr-2">
                  <input class="input-field" oninput="this.value = this.value.toUpperCase()" name="account_legal_name" 
                    formControlName="account_legal_name" type="text"/>
                  <label>Client Legal Name</label>
                </div>
              </div>

        </div>

        <div class="text-input-group d-flex justify-content-between" *ngIf="masterType == 'airline'">
          <div style="width: 200px;" class="text-input-field mr-2">
            <input class="input-field"  oninput="this.value = this.value.toUpperCase()"
              formControlName="2_ltr_code" type="text" />
            <label>2 LTR-CODE</label>
          </div>
          <div style="width: 200px;" class="text-input-field mr-2">
            <input  class="input-field" oninput="this.value = this.value.toUpperCase()"
              formControlName="3_ltr_code" type="text" />
            <label>3 LTR-CODE</label>
          </div>
          <div style="width: 250px;" class="text-input-field">
            <input class="input-field"  oninput="this.value = this.value.toUpperCase()"
            value ="{{masterForm.value['2_ltr_code'] + masterForm.value['3_ltr_code']}}" type="text"  disabled />
            <label>Airline Code</label>
          </div>
          </div>
  
       
      
        <div *ngIf="['client', 'supplier', 'hotel'].includes(masterType)">
          <div class="form-group text-input-field">
              <input class="input-field" oninput="this.value = this.value.toUpperCase()" name="address_1" 
                formControlName="address_1" type="text" [ngClass]="{'error-field': masterForm.controls.address_1.invalid && masterForm.controls.address_1.dirty || (!masterForm.controls.address_1.valid && submitted),
                  'success-field' : masterForm.controls.address_1.valid && masterForm.controls.address_1.dirty }" />
              <label
                [ngClass]="{'error-label': masterForm.controls.address_1.invalid && masterForm.controls.address_1.dirty || (!masterForm.controls.address_1.valid && submitted)}">Address
      
                <ng-container
                  *ngIf="masterForm.controls.address_1.invalid && masterForm.controls.address_1.dirty || (!masterForm.controls.address_1.valid && submitted)">
                  <i class="fa fa-info-circle ml-2" title="Required Address" aria-hidden="true"></i>
                </ng-container>
              </label>
      
            </div>

            <div class="text-input-group d-flex justify-content-between">
              <div class="text-input-field mr-2">
                <select class="input-field" oninput="this.value = this.value.toUpperCase()" tabIndex="4"
                  formControlName="country_id" (change)="getStates($event.target.value)">
                  <option *ngFor="let country of countryArr" value="{{country.location_id}}">{{country.name}}</option>
                </select>
                <label>Country</label>
              </div>

              <div class="text-input-field mr-2">
                <select class="input-field" oninput="this.value = this.value.toUpperCase()" tabIndex="5"
                  formControlName="state_id" (change)="getCities($event.target.value)">
                  <option *ngFor="let state of stateArr" value="{{state.location_id}}">{{state.name}}</option>
                </select>
                <label>State</label>
              </div>


              <div class="text-input-field">
                <select class="input-field" oninput="this.value = this.value.toUpperCase()" tabIndex="6"
                  formControlName="city_id" (change)="getCityName($event.target.value)">
                  <option *ngFor="let city of cityArr" value="{{city.location_id}}">{{city.name}}</option>
                </select>
                <label>City</label>
              </div>
            </div>

            <div class="text-input-group d-flex justify-content-between">
              <div class="text-input-field mr-2">
                <input class="input-field" oninput="this.value = this.value.toUpperCase()" name="gst_number" 
                  formControlName="gst_number" type="text" maxlength="15"
                  pattern="^([0][1-9]|[1-2][0-9]|[3][0-7])([a-zA-Z]{5}[0-9]{4}[a-zA-Z]{1}[1-9a-zA-Z]{1}[zZ]{1}[0-9a-zA-Z]{1})+$"
                  [ngClass]="{'error-field': masterForm.controls.gst_number.invalid && masterForm.controls.gst_number.dirty || (!masterForm.controls.gst_number.valid && submitted),
                  'success-field' : masterForm.controls.gst_number.valid && masterForm.controls.gst_number.dirty}" />
                <label
                  [ngClass]="{'error-label': masterForm.controls.gst_number.invalid && masterForm.controls.gst_number.dirty} || (!masterForm.controls.gst_number.valid && submitted)">
                  GST NUMBER
                  <ng-container
                    *ngIf="masterForm.controls.gst_number.invalid && masterForm.controls.gst_number.dirty || (!masterForm.controls.gst_number.valid && submitted)">
                    <i class="fa fa-info-circle ml-2" title="Invalid GST Number ( ex: 12ABCDE1234F1Z3)"
                      aria-hidden="true"></i>
                  </ng-container>
                </label>
              </div>
              <div class="text-input-field">
                <input class="input-field" oninput="this.value = this.value.toUpperCase()" name="gst_expiry_date" 
                  formControlName="gst_expiry_date" type="date"
                  [ngClass]="{'error-field': masterForm.controls.gst_expiry_date.invalid && masterForm.controls.gst_expiry_date.dirty  || (!masterForm.controls.gst_expiry_date.valid && submitted),
                    'success-field' : masterForm.controls.gst_expiry_date.valid && masterForm.controls.gst_expiry_date.dirty}" />
                <label
                  [ngClass]="{'error-label': masterForm.controls.gst_expiry_date.invalid && masterForm.controls.gst_expiry_date.dirty}  || (!masterForm.controls.gst_expiry_date.valid && submitted)">Expiry
                  Date
                  <ng-container
                    *ngIf="masterForm.controls.gst_expiry_date.invalid && masterForm.controls.gst_expiry_date.dirty  || (!masterForm.controls.gst_expiry_date.valid && submitted)">
                    <i class="fa fa-info-circle ml-2" title="required expiry date" aria-hidden="true"></i>
                  </ng-container>
                </label>
              </div>
            </div>

            <div class="text-input-group d-flex justify-content-between">
              <div class="text-input-field mr-2">
                  <input class="input-field" oninput="this.value = this.value.toUpperCase()" name="mobile_no" minlength="10"
                    maxlength="10"  formControlName="mobile_no" type="text" pattern="([0-9]+)" [ngClass]="{'error-field': masterForm.controls.mobile_no.invalid && masterForm.controls.mobile_no.dirty  || (!masterForm.controls.mobile_no.valid && submitted),
                  'success-field' : masterForm.controls.mobile_no.valid && masterForm.controls.mobile_no.dirty}" />
                  <label
                    [ngClass]="{'error-label': masterForm.controls.mobile_no.invalid && masterForm.controls.mobile_no.dirty  || (!masterForm.controls.mobile_no.valid && submitted)}">Mobile
                    No.
                    <ng-container
                      *ngIf="masterForm.controls.mobile_no.invalid && masterForm.controls.mobile_no.dirty  || (!masterForm.controls.mobile_no.valid && submitted)">
                      <i class="fa fa-info-circle ml-2" title="Invalid Mobile Number" aria-hidden="true"></i>
                    </ng-container>
                  </label>
              </div>
              <div class="text-input-field">
                <input class="input-field" oninput="this.value = this.value.toUpperCase()" name="primary_email" 
                  formControlName="primary_email" type="text" pattern="^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,100})+$"
                  [ngClass]="{'error-field': masterForm.controls.primary_email.invalid && masterForm.controls.primary_email.dirty  || (!masterForm.controls.primary_email.valid && submitted),
                'success-field' : masterForm.controls.primary_email.valid && masterForm.controls.primary_email.dirty}" />
                <label
                  [ngClass]="{'error-label': masterForm.controls.primary_email.invalid && masterForm.controls.primary_email.dirty  || (!masterForm.controls.primary_email.valid && submitted)}">Email
                  #1<ng-container
                    *ngIf="masterForm.controls.primary_email.invalid && masterForm.controls.primary_email.dirty  || (!masterForm.controls.primary_email.valid && submitted)">
                    <i class="fa fa-info-circle ml-2" title="Invalid Email" aria-hidden="true"></i>
                  </ng-container>
                </label>
      
              </div>
            </div>

            <div class="text-input-group d-flex justify-content-between">
              <div class="text-input-field mr-2">
                <input class="input-field" oninput="this.value = this.value.toUpperCase()"
                  name="pan_number" tabIndex="13" formControlName="pan_number" type="text" maxlength="10"
                  pattern="([a-zA-Z]{5})(\d{4})([a-zA-Z]{1})$" [ngClass]="{'error-field': masterForm.controls.pan_number.invalid && masterForm.controls.pan_number.dirty,
              'success-field' : masterForm.controls.pan_number.valid && masterForm.controls.pan_number.dirty}" />
                <label
                  [ngClass]="{'error-label': masterForm.controls.pan_number.invalid && masterForm.controls.pan_number.dirty}">PAN
                  NO. <ng-container *ngIf="masterForm.controls.pan_number.invalid && masterForm.controls.pan_number.dirty">
                    <i class="fa fa-info-circle ml-2" title="Invalid pan number" aria-hidden="true"></i>
                  </ng-container>
                </label>
              </div>
           
                <div class="text-input-field">
                  <label class="ngauto-label" for="affname"
                    [ngClass]="{'error-label': masterForm.controls.sales_person_name.invalid && masterForm.controls.sales_person_name.dirty || (!masterForm.controls.sales_person_name.valid && submitted)}">Sales
                    Person
                    <ng-container
                      *ngIf="masterForm.controls.sales_person_name.invalid && masterForm.controls.sales_person_name.dirty || (!masterForm.controls.sales_person_name.valid && submitted)">
                      <i class="fa fa-info-circle ml-2" title="Sales Person Required" aria-hidden="true"></i>
                    </ng-container>
                  </label>
                  <div class="ng-autocomplete w-100" (focus)="focusSalesPerson($event)" tabIndex="14">
                    <ng-autocomplete #salesPersonAC
                      [ngClass]="{'error-ng-field': masterForm.controls.sales_person_name.invalid && masterForm.controls.sales_person_name.dirty || (!masterForm.controls.sales_person_name.valid && submitted),
                  'success-ng-field' : masterForm.controls.sales_person_name.valid && masterForm.controls.sales_person_name.dirty }"
                      [data]="salesPersonArr" [searchKeyword]="keyword" (inputChanged)='getSalesPerson($event)'
                      [itemTemplate]="itemTemplate" (selected)="selectSalesPerson($event)" formControlName="sales_person_name"
                      [notFoundTemplate]="notFoundTemplate">
                    </ng-autocomplete>
                    <ng-template #itemTemplate let-item>
                      <a innerHTML='<span class="colr-1">{{item.name}}
                                        ({{item.account_code}})</span><br />
                                    <span class="colr-2">{{item.primary_email}}</span><br />'>
                      </a>
                    </ng-template>
                    <ng-template #notFoundTemplate let-notFound>
                      <div [innerHTML]="notFound"></div>
                    </ng-template>
                  </div>
                </div>
            </div>
            <div class="text-input-group d-flex justify-content-between" *ngIf="showCategoryField || showSourceField">
    <div class="text-input-field mr-2">
      <label class="ngauto-label" for="category_list"
        [ngClass]="{'error-label': masterForm.controls.category_list.invalid && masterForm.controls.category_list.dirty || (!masterForm.controls.category_list.valid && submitted)}">
        Category
        <ng-container
          *ngIf="masterForm.controls.category_list.invalid && masterForm.controls.category_list.dirty || (!masterForm.controls.category_list.valid && submitted)">
          <i class="fa fa-info-circle ml-2" title="Category Required" aria-hidden="true"></i>
        </ng-container>
      </label>
      
      <select class="input-field" tabIndex="18" formControlName="category_list">
        <option value="">Select Category</option>
        <option *ngFor="let category of categoryOptions" [value]="category">{{category}}</option>
      </select>
    </div>

    <div class="text-input-field">
      <label class="ngauto-label" for="source_list"
        [ngClass]="{'error-label': masterForm.controls.source_list.invalid && masterForm.controls.source_list.dirty || (!masterForm.controls.source_list.valid && submitted)}">
        Source
        <ng-container
          *ngIf="masterForm.controls.source_list.invalid && masterForm.controls.source_list.dirty || (!masterForm.controls.source_list.valid && submitted)">
          <i class="fa fa-info-circle ml-2" title="Source Required" aria-hidden="true"></i>
        </ng-container>
      </label>
      
      <select class="input-field" tabIndex="19" formControlName="source_list">
        <option value="">Select Source</option>
        <option *ngFor="let source of sourceOptions" [value]="source">{{source}}</option>
      </select>
    </div>
    </div>

          </div>
        
        <div class="mt-3 d-flex justify-content-center align-item-center">
        <button type="button" class="btn-style bg-red mr-2" data-dismiss="modal">
            Cancel
        </button>
        <button
            type="button"
            class="btn-style bg-green"
            (click)="openConfirmationModal()"
        >
            Save
        </button>
        </div>

    </form>
</div>
   

<button type="button" hidden #confirmCreateModal data-toggle="modal" data-target="#createConfirmModal"></button>

<div class="modal fade" id="createConfirmModal" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true" data-backdrop="false">
    <div class="modal-dialog modal-md" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h4>Confirmation</h4>
                <button type="button" class="close" #closeCreateModal  aria-label="Close" (click)="openConfirmationModal()">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                Are you sure to <b>Create {{masterType}}</b> ?
            </div>
            <div class="modal-footer">
                <button type="button" class="btn-style bg-red mr-2"  (click)="openConfirmationModal()">No</button>
                <button type="button" class="btn-style bg-blue" (click)="saveMaster(false)">Yes</button>
            </div>
        </div>
    </div>
</div>

<button type="button" hidden #openWarningModal data-toggle="modal" data-target="#warningModal"></button>
<div id="warningModal" class="modal fade" role="dialog" data-backdrop="false">
  <div class="modal-dialog transaction-creation-modal">
    <div class="modal-content">

      
      <div class="modal-header">
        <img src="{{commonService.aws_asset_url}}/_assets/icons/light-mode/red-warning.svg" width="20px" height="20px"
            alt="alert-logo" class="mr-20" />
        <span class="messageFont">
          <span>Warning</span>
        </span>
        <button type="button" #closeWarningModal class="close" data-dismiss="modal">&times;</button>
      </div>

      <div class="modal-body">
        <p [innerHTML]="warningMessage"></p>
      </div>
    
      <div class="modal-footer justify-content-center">
        <button type="button"
                class="btn btn-primary"
                (click)="saveMaster(true)">
          Create, I Understand
        </button>
        <button type="button"
                class="btn btn-primary"
                data-dismiss="modal">
          Cancel
        </button>
      </div>

    </div>
  </div>
</div>